import { TFunction } from 'i18next'
import { z } from 'zod'

import { PMS_CONNECTABLE_PROVIDERS, PmsProvider } from '@/api/pms'
import { SelectOption } from '@/components/ui/select'

export const PmsConnectProviderSchema = z.enum(PMS_CONNECTABLE_PROVIDERS)

export const PmsConnectProvider = PmsConnectProviderSchema.enum

export type PmsConnectProvider = z.infer<typeof PmsConnectProviderSchema>

export type PmsCompanyField =
  | 'companyCode'
  | 'database'
  | 'managementCompany'
  | 'name'
  | 'password'
  | 'pmcid'
  | 'serverName'
  | 'url'
  | 'username'

// Note: field names are what the backend expects when a management company is created
export const PMS_COMPANY_FIELDS: Record<PmsConnectProvider, readonly PmsCompanyField[]> = {
  entrata: ['name', 'managementCompany', 'username', 'password'],
  realPage: ['name', 'pmcid'],
  rentManager: ['name', 'username', 'password', 'companyCode'],
  yardi: ['name', 'username', 'password', 'serverName', 'database', 'url'],
}

export const getPmsTypeOptions = (t: TFunction<['organisation']>): SelectOption<PmsProvider>[] => [
  { label: t('organisation:places.integrations.pms.types.yardi'), value: 'yardi' },
  { label: t('organisation:places.integrations.pms.types.realPage'), value: 'realPage' },
  { label: t('organisation:places.integrations.pms.types.entrata'), value: 'entrata' },
  { label: t('organisation:places.integrations.pms.types.rentManager'), value: 'rentManager' },
  {
    disabled: true,
    label: t('organisation:places.integrations.pms.types.resman'),
    value: 'resman',
  },
]

export const makePmsConnectSchema = (t: TFunction<['organisation']>) =>
  z.object({
    company: z
      .number({ message: t('organisation:places.pms.validation.companyRequired') })
      .int(t('organisation:places.pms.validation.companyRequired')),
    property: z.string().min(1, t('organisation:places.pms.validation.propertyRequired')),
    type: PmsConnectProviderSchema,
  })

export type PmsConnectFormData = z.infer<ReturnType<typeof makePmsConnectSchema>>

export const makePmsCompanySchema = (provider: PmsConnectProvider, requiredMessage: string) =>
  z.object(
    Object.fromEntries(
      PMS_COMPANY_FIELDS[provider].map((field) => [
        field,
        z.string().trim().min(1, requiredMessage),
      ]),
    ),
  )
